import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import AboutView from '@/views/AboutView.vue'
import SchemeView from '@/views/SchemeView.vue'
import CaseView from '@/views/CaseView.vue'
import ExplorationVehicle from '@/views/product/ExplorationVehicle.vue'
import BuildingView from '@/views/product/buildingView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '首页' }
  },
  {
    path: '/scheme',
    name: 'scheme',
    component: SchemeView,
    meta: { title: '产品及方案中心' }
  },
  {
    path: '/case',
    name: 'case',
    component: CaseView,
    meta: { title: '应用案例' }
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
    meta: { title: '关于我们' }
  },
  {
    path: '/ExplorationVehicle',
    name: 'ExplorationVehicle',
    component: ExplorationVehicle
  },
  {
    path: '/product',
    name: 'building',
    component: BuildingView
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.meta.keepAlive) {
      return false
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach((to, from, next) => {
  //window.scrollTo(0, 0); // 滚动到顶部
  next();
});
export default router
